import { Drawer } from 'antd';
import React from 'react';
import Aside from '../Aside';

const AsideDrawer = ({ open, onClose, branding }) => {
  return (
    <Drawer
      title={branding}
      placement="left"
      styles={{
        body: {
          padding: 18
        }
      }}
      headerStyle={{ maxHeight: '50px' }}
      onClose={onClose}
      open={open}
      classNames={{
        header: 'aside-drawer-header',
      }}
      width={300}
    >
      <Aside onClose={onClose} />
    </Drawer>
  );
};

export default AsideDrawer;
